import { useState } from "react";
import api from "../api/axios";

const useEmployeeLocation = () => {
  const [userLocation, setUserLocation] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [locationErrorMessage, setLocationErrorMessage] = useState("");

  const getEmployeeCurrentPosition = (company_id) => {
    return new Promise((resolve) => {
      if (!navigator.geolocation) {
        setLocationErrorMessage(
          "Geolocation is not supported by your browser."
        );
        setShowModal(true);
        resolve(false);
        return;
      }

      setIsLoading(true);
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          setUserLocation({ latitude, longitude });

          const locationAllowed = await checkEmployeeLocation(
            latitude,
            longitude,
            company_id
          );
          resolve(locationAllowed);
        },
        (error) => {
          setShowModal(true);
          setLocationErrorMessage(
            "Failed to retrieve location. Turn on location and give access to the app."
          );
          setIsLoading(false);
          resolve(false);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      );
    });
  };

  const checkEmployeeLocation = async (latitude, longitude, company_id) => {
    try {
      const response = await api.post(`auth/company_coordinates`, {
        latitude,
        longitude,
        company_id,
      });

      if (response.data.allowed) {
        setShowModal(false);
        return true;
      } else {
        setShowModal(true);
        setLocationErrorMessage(
          "You are not within the allowed location. Try to locate near the company radius."
        );
        return false;
      }
    } catch (error) {
      setLocationErrorMessage("Error checking location.");
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    userLocation,
    isLoading,
    showModal,
    locationErrorMessage,
    getEmployeeCurrentPosition,
    setShowModal,
  };
};

export default useEmployeeLocation;
